export const buildUnitPartyBindingPayload = (form = {}, canManagePartnerBindings = false) => {
  if (!canManagePartnerBindings) return {};
  return {
    kudOwnerId: form.rpOwnerId || null,
    puskudId: form.puskudId || null,
    stewardId: form.stewardId || null
  };
};
